<script lang="ts">
    import MediaQuery from "svelte-media-query";

    export let stepText: string;
	export let title: string;

	export let borderColor = '#c8c8c8';
</script>

<div class="stepper-container">

    <MediaQuery query="(max-width: 900px)" let:matches>
        {#if matches}
            <div class="empty"></div>
            {#if $$slots.left}
                <div class="stepper-left">
                    <slot name="left"></slot>
                </div>
            {:else}
                <div class="empty"></div>
            {/if}

            <div class="empty"></div>
            <div class="stepper-top-bar">
                <span class="red-title">{stepText}</span>
                <span class="stepper-title">{title}</span>
            </div>
            <div class="empty"></div>
        {:else}
            <div class="empty"></div>
            <div class="stepper-top-bar">
                <span class="red-title">{stepText}</span>
                <span class="stepper-title">{title}</span>
            </div>

            {#if $$slots.left}
                <div class="stepper-left">
                    <slot name="left"></slot>
                </div>
            {:else}
                <div class="empty"></div>
            {/if}
        {/if}
    </MediaQuery>

    <div class="stepper-inner-container">
        <div class="stepper-content" style="border-color: {borderColor}">
            <slot></slot>
        </div>

        <slot name="bottom"></slot>
    </div>
</div>

<style>
    .stepper-top-bar {
        margin-bottom: 20px;
        margin-left: 40px;

        margin-right: 55px;
    }
    .stepper-title {
        font-family: 'Open Sans', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 22px;
        color: #000000;

        margin-left: 40px;
    }
    /* 600px, 900px, 1200px, and 1800px */
    @media (max-width: 900px) {
        .stepper-title {
            margin-left: 5px;
        }
    }
    .stepper-left {
        margin-right: 10px;
    }
    .stepper-container {
        display: grid;
        grid-template-columns: min-content auto;
    }
    .stepper-inner-container {
        width: 100%;
    }
    .stepper-content {
        border: 1px solid #c8c8c8;
        border-radius: 10px;

        padding: 4em 3em;
    }
</style>
